import { AxiosResponse } from "axios";

import client from "../client";
import { postSignInAppleConfig } from "./postSignInAppleConfig";
import { PostSignInApplePayload } from "./types";
import { PostLoginResponseData } from "../postLogin/types";

const postSignInApple = async (
  data?: PostSignInApplePayload,
  reference?: string
): Promise<AxiosResponse<PostLoginResponseData>> => {
  return await client({
    ...postSignInAppleConfig,
    data: { reference, provider: "apple", ...data },
  });
};

export default { postSignInApple };
